
import useValidate from '@vuelidate/core'
import { defineComponent, PropType } from 'vue'
import { iBusinessModel } from '@/modules/managers/businessModelCatalogue/metaweb/Metaweb'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import MetawebBusinessViewDialog from '@/modules/managers/businessModelCatalogue/metaweb/businessModel/dialogs/MetawebBusinessViewDialog.vue'

export default defineComponent({
    name: 'metaweb-attributes-tab',
    components: { DataTable, Column, MetawebBusinessViewDialog },
    props: {
        selectedBusinessModel: { type: Object as PropType<iBusinessModel | null>, required: true },
        propMeta: { type: Object },
        observer: { type: Object }
    },
    emits: ['loading'],
    computed: {},
    data() {
        return {
            v$: useValidate() as any,
            businessModel: null as iBusinessModel | null,
            showBusinessViewDialog: false
        }
    },
    watch: {
        selectedBusinessModel() {
            this.loadData()
        }
    },
    created() {
        this.loadData()
    },
    validations() {},
    methods: {
        loadData() {
            this.businessModel = this.selectedBusinessModel as iBusinessModel
        }
    }
})
